import { COVER_VIDEO_SAMPLES } from './catalog';
import { COVER_FORMATS, coverPreset } from './cover-variants';
import { RENDER_PRESETS } from '../../domain/render-preset';
import { SAMPLE_DURATION_SECONDS, sampleVideoUrl } from './settings';

/** Skip the regional approach so the first paused frame already shows map detail. */
export const HOMEPAGE_OPENING_SECONDS = 3;
export const HOMEPAGE_PLAYBACK_SECONDS = SAMPLE_DURATION_SECONDS - HOMEPAGE_OPENING_SECONDS;
export const HOMEPAGE_VIDEO_SAMPLES = [
  ...COVER_VIDEO_SAMPLES.map(sample => ({ ...sample, mapLabel: sample.label, cameraLabel: 'Night Stalker' })),
  { id: 'night-hawk', label: 'Night Hawk', mapLabel: 'Terra', cameraLabel: 'Night Hawk',
    variants: Object.fromEntries(COVER_FORMATS.map(format => [format, {
      src: sampleVideoUrl(`camera-night-hawk-${format}`),
      output: RENDER_PRESETS.find(preset => preset.id === coverPreset(format))!,
    }])) as typeof COVER_VIDEO_SAMPLES[number]['variants'] },
];
